module.exports = [{
      plugin: require('/src/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1920,"linkImagesToOriginal":false},
    },{
      plugin: require('/src/node_modules/gatsby-plugin-lunr/gatsby-browser.js'),
      options: {"plugins":[],"languages":[{"name":"en"},{"name":"ru"}],"fields":[{"name":"title","store":true,"attributes":{"boost":20}},{"name":"excerpt"},{"name":"slug","store":true}],"resolvers":{"MarkdownRemark":{}},"filename":"search_index.json"},
    }]
